const fontFamilies = {
    heading: "'Porsche Next'",
    body: "'Porsche Next'",
};

export default fontFamilies;
